/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../theme/theme"
import { css } from "@mui/material"
import { LinearProgress, Typography } from "@mui/material"

interface ProgressBarProps {
    currentStep: number
    totalSteps: number
}

const ProgressContainerStyle = withMyTheme((theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
    margin: 0 2rem;
`)

const ProgressBarStyle = withMyTheme((theme) => css`
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background-color: ${theme.palette.grey[300]};
    
    .MuiLinearProgress-bar {
        background-color: ${theme.palette.primary.main};
        border-radius: 4px;
    }
`)

const ProgressTextStyle = withMyTheme((theme) => css`
    font-size: 0.9rem;
    font-weight: 600;
    color: ${theme.palette.primary.main};
`)

export const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
    const progressPercentage = ((currentStep + 1) / totalSteps) * 100
    
    return (
        <div css={ProgressContainerStyle}>
            <Typography css={ProgressTextStyle}>
                {Math.round(progressPercentage)}% Complete
            </Typography>
            <LinearProgress
                variant="determinate"
                value={progressPercentage}
                css={ProgressBarStyle}
            />
        </div>
    )
}